module.exports = __webpack_public_path__ + "img/f024ff85b16572eb42e2150cf1a23564.png";